import React from 'react';
import PropTypes from 'prop-types';
import CheckBoxBase from '../CheckBox/CheckBoxBase';
import styles from '../CheckBox/checkBox.scss';

const SimpleCheckBox = ({
    id,
    label,
    hiddenLabel,
    description,
    customLabel,
    customLabelClass,
    formGroupCssClass,
    disabled,
    checked,
    onChange,
    'data-testid': dataTestId,
}) => {
    const inputProps = { id, type: 'checkbox', checked, disabled };

    return (
        <div className={`form-group ${description ? 'description' : ''} ${styles.checkBox} ${formGroupCssClass || ''}`} data-testid={dataTestId || undefined}>
            <label htmlFor={id} className={hiddenLabel ? 'sr-only' : ''}>
                {label}
            </label>
            {description && <small>{description}</small>}
            <CheckBoxBase
                wrapperCssClass="input-wrapper"
                inputProps={inputProps}
                onChange={(val, e) => {
                    if (!disabled && onChange) {
                        onChange(val, e);
                    }
                }}
                customLabel={customLabel}
                customLabelClass={customLabelClass}
                checked={checked}
                disabled={disabled}
                data-testid={dataTestId}
            />
        </div>
    );
};

SimpleCheckBox.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    hiddenLabel: PropTypes.bool,
    description: PropTypes.string,
    customLabel: PropTypes.string,
    customLabelClass: PropTypes.string,
    formGroupCssClass: PropTypes.string,
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    'data-testid': PropTypes.string,
};

SimpleCheckBox.defaultProps = {
    label: '',
    hiddenLabel: false,
    description: '',
    customLabel: '',
    customLabelClass: '',
    formGroupCssClass: '',
    disabled: false,
    checked: false,
    onChange: null,
    'data-testid': null,
};

export default SimpleCheckBox;
